import {
  ErrorOutlineOutlined,
  InfoOutlined,
  WarningOutlined,
} from "@mui/icons-material";
import {
  Button,
  ButtonPropsColorOverrides,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";
import React from "react";

interface ConfirmationDialogProps {
  title: string;
  content: string;
  variant?: "warning" | "primary" | "error";
  onContinue: () => void;
  onClose: () => void;
  continueBtnText?: string;
  continueBtnColor?:
    | "warning"
    | "info"
    | "error"
    | "inherit"
    | "primary"
    | "secondary"
    | "success";
  cancelBtnText?: string;
  open: boolean;
  className: string;
}

const ConfirmationDialog = ({
  title,
  content,
  variant = "primary",
  onClose,
  onContinue,
  continueBtnText = "Continue",
  cancelBtnText = "Cancel",
  open = false,
  className,
}: ConfirmationDialogProps) => {
  return (
    <Dialog className={className} onClose={onClose} open={open}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Grid container alignItems="center">
          <Grid item xs={2}>
            {variant === "warning" ? (
              <WarningOutlined color="warning" fontSize="large" />
            ) : variant === "error" ? (
              <ErrorOutlineOutlined color="error" fontSize="large" />
            ) : (
              <InfoOutlined sx={{ color: "#1976d2" }} fontSize="large" />
            )}
          </Grid>
          <Grid item xs={10} pr={1}>
            <DialogContentText sx={{ textAlign: "left", fontSize: "0.875rem" }}>
              {content}
            </DialogContentText>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", mb: "1rem" }}>
        <Button variant="contained" color={variant} onClick={onContinue}>
          {continueBtnText}
        </Button>
        <Button onClick={onClose}>{cancelBtnText}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
